import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ControlBase } from '../control';

/**
 * <ds365-input [group]="userForm" controlName="firstName" id="id" type="text" size="sm" readonly="false"
 *    readonlyPlain="false" placeholder="First Name" requiredMsg="First Name is required">
 *    <ng-container label>First Name</ng-container>
 *   <ng-container hints>First Name Should be alphabets only.</ng-container>
 * </ds365-input>
 */
@Component({
  selector: 'ds365-input-group',
  templateUrl: 'input-group.component.html',
  styleUrls: ['./input-group.component.scss'],
  standalone: false
})
export class InputGroupComponent implements ControlBase {
  @Input() group: FormGroup;
  @Input() controlNameText: any;
  @Input() controlNameSelect: any;

  @Input() id: string;
  @Input() type: 'text' | 'email' | 'number' | 'phone' = 'text';
  @Input() size: 'lg' | 'sm';

  @Input() readonly: boolean;
  @Input() readonlyPlain: boolean;

  @Input() options: { key: string; title: string }[] = [];
  @Input() delimiter: string = '@';
  selectedOption: any;



  @Input() placeholder: string;
  @Input() requiredMsg: string;

  @Input() maxLength: number;
  @Input() minLength: number;

  @Input() max: number;
  @Input() min: number;

  @Input() icon: string;
  @Input() iconStyle: any;
  @Input() iconStatus = 'dark';
  @Input() styles = {}
  @Input() showLabel = true;
  @Input() showError = true;

  isVisible=false;


  @Output()
  iconEvent = new EventEmitter();
  @Output()
  valueChange = new EventEmitter();
  errorMessage = '';

  constructor() {

  }

  ngOnInit() {
    this.selectedOption = this.options[0];
    const control = this.group?.get(this.controlNameSelect);
    control?.setValue(`${this.selectedOption.key}`);
  }

  onDropdownSelect(option: { key: string; title: string }) {
    this.selectedOption = option;
    const control = this.group?.get(this.controlNameSelect);
    control?.setValue(`${this.selectedOption.key}`);
  }



  get classes() {
    const classObj:any = {
      'form-control': true,
      'form-control-plaintext': this.readonlyPlain,
      'input-pl': this.icon,
    };
    if (this.size) {
      classObj['form-control-' + this.size] = true;
    }
    return classObj;
  }

  iconClick() {
    this.iconEvent.emit(true);
  }
  onInputChange(value: any) {
    this.valueChange.emit(true);
  }
}
